import { createSlice } from '@reduxjs/toolkit';
import { pageModel } from '../../utils/model';

const initialState = {
    page: pageModel
}

const colorSlice = createSlice({
    name: 'color',
    initialState,
    reducers: {
        setColorPageAction: (state, action) => {
            state.page = action.payload
        },
        getColorPageAction: (state, action) => {
            const content = state.page.content.concat(action.payload.content)
            state.page = { ...action.payload, content }
        },
        addColorAction: (state, action) => {
            state.page.content.unshift(action.payload)
        },
        updateColorAction: (state, action) => {
            const content = state.page.content.map((color) => {
                if (color.id === action.payload.id) return action.payload
                else return color
            })
            state.page.content = content
        },
        deleteColorAction: (state, action) => {
            const content = state.page.content.filter(color => color.id !== action.payload)
            state.page.content = content
        },
        uploadExcelFileAction: (state, action) => {
            let content = [...action.payload.reverse(), ...state.page.content]
            state.page.content = content
            // state.page.content = content
        }
    },
});

export const { setColorPageAction, getColorPageAction, addColorAction, updateColorAction, deleteColorAction, uploadExcelFileAction } = colorSlice.actions;
export default colorSlice;